/* unplugin-vue-components disabled */import script from "./HandicapView.vue?vue&type=script&setup=true&lang=js"
export * from "./HandicapView.vue?vue&type=script&setup=true&lang=js"

import "./HandicapView.vue?vue&type=style&index=0&id=0cb49c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb49c04"]])

export default __exports__